import { signatureFileName } from "./signature";
import interiorsTemplate from "./templates/saksham-interiors";
import eliteTemplate from "./templates/elite-enterprises";
import marketingTemplate from "./templates/saksham-marketing";
import haronitTemplate from "./templates/haronit-international";

export const COMPANIES = [
  {
    id: "saksham-interiors", label: "Saksham Interiors Private Limited", emailDomain: "@sakshaminteriors.in", template: interiorsTemplate,
    logoUrl: "https://saksham-email-signature-generator.pages.dev/assets/signatures/saksham-interiors-logo.png",
    dividerUrl: "https://saksham-email-signature-generator.pages.dev/assets/signatures/saksham-marketing-divider.png",
  },
  {
    id: "elite-enterprises", label: "Elite Enterprises", emailDomain: "@eliteenterprises.in", template: eliteTemplate,
    logoUrl: "https://saksham-email-signature-generator.pages.dev/assets/signatures/elite-enterprises-logo.png",
    dividerUrl: "https://saksham-email-signature-generator.pages.dev/assets/signatures/elite-enterprises-divider.png",
  },
  {
    id: "saksham-marketing", label: "Saksham Marketing", emailDomain: "@sakshammarketing.in", template: marketingTemplate,
    logoUrl: "https://saksham-email-signature-generator.pages.dev/assets/signatures/saksham-marketing-logo.png",
    dividerUrl: "https://saksham-email-signature-generator.pages.dev/assets/signatures/saksham-marketing-divider.png",
  },
  {
    id: "haronit-international", label: "Haronit International Private Limited", emailDomain: "@haronit.in", template: haronitTemplate,
    logoUrl: "https://saksham-email-signature-generator.pages.dev/assets/signatures/haronit-international-logo.png",
    dividerUrl: "https://saksham-email-signature-generator.pages.dev/assets/signatures/haronit-international-divider.png",
  },
];

const escapeHtml = (value = "") => String(value)
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
const telHref = (value = "") => `tel:${String(value).replace(/[^\d+]/g, "")}`;

// All brands use approved master documents, not reconstructed layouts.
export function renderCompanySignature(data, companyId = "saksham-interiors") {
  const company = COMPANIES.find((item) => item.id === companyId);
  if (!company) throw new Error("Unknown company");
  const values = {
    name: escapeHtml(data.name), title: escapeHtml(data.title),
    mobile: escapeHtml(data.mobile), mobileHref: escapeHtml(telHref(data.mobile)),
    email: escapeHtml(data.email), emailHref: escapeHtml(`mailto:${data.email || ""}`),
    logoUrl: company.logoUrl, dividerUrl: company.dividerUrl,
    secondMobile: data.mobile2
      ? `&nbsp;/&nbsp;<a href="${escapeHtml(telHref(data.mobile2))}" style="color:#202625;text-decoration:none;">${escapeHtml(data.mobile2)}</a>`
      : "",
  };
  // One substitution pass means user text containing {{tokens}} stays literal.
  const document = company.template.replace(/\{\{(\w+)\}\}/g, (_, key) => values[key]);
  const html = document.match(/<body[^>]*>([\s\S]*?)<\/body>/i)[1].trim();
  return {
    html, document,
    filename: company.id === "saksham-interiors"
      ? signatureFileName(data.name)
      : signatureFileName(data.name).replace("-Saksham-Signature.html", `-${company.label.replace(/\s+/g, "-")}-Signature.html`),
  };
}

export function signaturePlainText(html) {
  const doc = new DOMParser().parseFromString(
    html.replace(/<br\s*\/?>/gi, "\n").replace(/<\/tr>/gi, "\n</tr>"), "text/html"
  );
  return doc.body.textContent.split("\n").map((line) => line.trim()).filter(Boolean).join("\n");
}
